import React from 'react';

import classnames from 'classnames';

import { MenuItem, Grid } from 'e100-react-components';
import { Icon } from 'components';
import { Typography } from 'shared/components';
import { Show } from '../../Show';

import { LegacyRef } from 'react';
import { IPropTypes as ButtonPropTypes } from 'e100-react-components/lib/components/Button';
import { IconProps } from 'components';

import { useStyles } from './styles';

export const AppMenuItem = ({
  icon,
  title,
  selected,
  onClick,
  id,
  containerRef,
  classes
}: AppMenuItemProps) => {
  const innerClasses = useStyles();

  return (
    <MenuItem
      disableGutters
      classes={{
        root: innerClasses.container
      }}
      onClick={onClick as any}
      id={id}
    >
      <div className={innerClasses.subContainer} ref={containerRef as LegacyRef<HTMLDivElement> | undefined}>
        <Grid
          container
          direction='column'
          spacing={0}
          alignContent="center"
          alignItems="center"
        >
          <Show when={!!icon}>
            <Grid item>
              <Icon
                kind={icon}
                classes={{ root: classnames(innerClasses.icon, classes?.icon) }}
                color={selected ? 'primary' : 'inherit'}
              />
            </Grid>
          </Show>
        </Grid>
        <Show when={!!title}>
          <Typography
            variant="caption"
            textAlign='center'
            classes={{ root: innerClasses.title }}
            color={selected ? 'primary' : 'inherit'}
          >
            {title}
          </Typography>
        </Show>
      </div>
    </MenuItem>
  );
};

interface Classes {
  icon?: string;
}

interface AppMenuItemProps {
  icon?: IconProps['kind'];
  title?: string;
  selected?: boolean;
  onClick?: ButtonPropTypes['onClick'];
  id?: string;
  containerRef?: React.MutableRefObject<HTMLDivElement | undefined>;
  classes?: Classes;
}
